import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-main-footer',
  templateUrl: './main-footer.component.html',
  styleUrls: ['./main-footer.component.scss'],
  encapsulation: ViewEncapsulation.None, // apply global styles to this component
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class MainFooterComponent {}
